import { Spinner, SpinnerSize } from '@fluentui/react';
import 'office-ui-fabric-react/dist/css/fabric.css';
import { UserSubscriptionsType } from '../../../../services/SubscriptionService';
import SubscriptionTable from './SubscriptionTable';

interface SubscriptionTableLogicProps {
    subscriptions?: UserSubscriptionsType[];
    loading: boolean;
}

const SubscriptionTableLogic = (props: SubscriptionTableLogicProps) => {
    const { subscriptions, loading } = props;

    var columns = [
        {
            id: 'savingsPlan',
            title: "Plan"
        },
        {
            id: 'startDate',
            title: "Fecha de Inicio"
        },
        {
            id: 'endDate',
            title: "Fecha de Fin"
        },
        {
            id: 'status',
            title: "Estado"
        }
    ];

    if (loading) {
        return (<Spinner size={SpinnerSize.large} />);
    }
    else {
        return (
            <SubscriptionTable
                tableTitle={"Suscripciones del Cliente"}
                tableCount={subscriptions?.length}
                rowData={subscriptions as UserSubscriptionsType[]}
                columnTitles={columns}
            />
        );
    }
};

export default SubscriptionTableLogic;